import CoreDrawer from '@/components/CoreDrawer';
import { Spin } from 'antd';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import GetDetailCountry from '../../viewmodels/countries-detail.viewmodel';
import { CountryForm } from './CountryForm';
import { get } from 'lodash';

interface Props {
  open: boolean;
  handleClose: () => void;
  setOpen: (value: boolean) => void;
}

export const DetailCountry = (props: Props) => {
  const { open, setOpen, handleClose } = props;
  const { loadingCountry, errorCountry, detailCountry, actionGetDetail } = GetDetailCountry();

  const [currentQueryParameters] = useSearchParams();
  const showId = currentQueryParameters.get('id');
  const getAction = currentQueryParameters.get('action');

  useEffect(() => {
    if ((showId !== null && getAction === 'Detail') || getAction === 'Create') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [open, handleClose, setOpen]);

  useEffect(() => {
    if (showId) {
      actionGetDetail();
    }
  }, [open]);

  const renderContent = () => {
    return (
      <>
        <div>{loadingCountry && <Spin />}</div>
        {errorCountry && <div>Error</div>}
        {!errorCountry && !loadingCountry && (
          <CountryForm detailCountry={get(detailCountry, 'data')} openForm={open} />
        )}
      </>
    );
  };

  return (
    <CoreDrawer
      open={open}
      onClose={() => handleClose()}
      content={renderContent()}
      bodyStyle={{ marginTop: '20px' }}
    />
  );
};
